"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _utils = require('shared/store/utils');
var _helpers = require('shared/actions/helpers');








// The Directory import's commands. Nothing stores their answers: the import
// dialog and the Patients tab keep them in local state.

const previewDirectoryImportActions = _utils.createAsyncActions('PreviewDirectoryImport')
const downloadDirectoryImportErrorsActions = _utils.createAsyncActions('DownloadDirectoryImportErrors')
const startDirectoryImportActions = _utils.createAsyncActions('StartDirectoryImport')
const getDirectoryImportStatusActions = _utils.createAsyncActions('GetDirectoryImportStatus')

// Reading and matching a 50,000-row file takes the server a while.
const FILE_TTL = 120000

const previewDirectoryImport = (req) =>
  _helpers.wsCommand('PreviewDirectoryImport', previewDirectoryImportActions, req, null, undefined, FILE_TTL)

const downloadDirectoryImportErrors = (req) =>
  _helpers.wsCommand('DownloadDirectoryImportErrors', downloadDirectoryImportErrorsActions, req, null, undefined, FILE_TTL)

const startDirectoryImport = (req) =>
  _helpers.wsCommand('StartDirectoryImport', startDirectoryImportActions, req, null, undefined, FILE_TTL)

const getDirectoryImportStatus = (req) =>
  _helpers.wsCommand('GetDirectoryImportStatus', getDirectoryImportStatusActions, req, null)

exports. default = {
  previewDirectoryImport,
  downloadDirectoryImportErrors,
  startDirectoryImport,
  getDirectoryImportStatus,
}
